import React, {useEffect, useState} from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import {Bar} from 'react-chartjs-2';
import faker from 'faker';
import {moderateScale} from '../../tools/Scaling';
import * as Colors from '../../tools/Colors';
import {typeExport} from '../../redux/store/type';
import HMTextView from '../HMTextView';
import {View} from 'react-native';
import {Tools} from '../../tools/Tools';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
);

export const options = {
    /* tooltip:{
         bodyFontSize:moderateScale(100),

     },*/
    legend: {
        labels: {
            usePointStyle: true,
            boxWidth: moderateScale(6),
        },
    },
    maintainAspectRatio: false,
    scaleShowValues: true,

    scales: {
        yAxes: [
            {
                ticks: {
                    beginAtZero: true,
                    fontColor: Colors.blackLight,
                    fontFamily: typeExport.regularFontName,
                    fontSize: moderateScale(14),
                    fontStyle: 'bold',
                },
            },
        ],
        xAxes: [{
            /*     fontFamily: i18n.locale == 'en' ? typeExport.regularFontName : typeExport.regularFontName,
                 fontWeight:"bold",

                 //   fontFamily: "IRANSansMobile(FaNum)_Bold",

                 //valueFormatter: ['1990', '1991', '1992', '1993', '1994'],

                 textSize:1000,
                 granularityEnabled: true,
                 granularity: 1,
                 axisMaximum: 3,
                 axisMinimum: 0,
                 centerAxisLabels: true,
                 position:"BOTTOM",*/
            ticks: {
                autoSkip: false,
                fontColor: Colors.blackLight,
                fontFamily: typeExport.regularFontName,
                fontSize: moderateScale(14),
                fontStyle: 'bold',
            },
        }],
    },
};

const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

export const data = {
    labels,
    datasets: [
        {
            label: 'Dataset 1',
            data: labels.map(() => faker.datatype.number({min: 0, max: 1000})),
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
        },
        {
            label: 'Dataset 2',
            data: labels.map(() => faker.datatype.number({min: 0, max: 1000})),
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
        },
    ],
};

function HMStackedBarChart(props) {
    let {title, styleTitle, styleRootTitle} = props;
    const [dataChart, setDataChart] = useState(0);

    useEffect(() => {
        let item = props.item;
        let myService = props.myService;

        /*        let item =[
                    {
                        "NAME": "INTERNET",
                        "FNAME": "اینترنت بین الملل",
                        "IN": 5659874562,
                        "OUT": 15987453214,
                        "CREDITUSED": 125645,
                        "URL": ""
                    },
                    {
                        "NAME": "INTERNAL",
                        "FNAME": "سایت های داخلی",
                        "IN": 12548963584,
                        "OUT": 1358745699,
                        "CREDITUSED": 266412,
                        "URL": "https:\/\/icip.ito.gov.ir\/index.php\/site\/page\/view\/list_ip"
                    },
                    {
                        "NAME": "VOD",
                        "FNAME": "تلویزیون اینترنتی",
                        "IN": 28656487543,
                        "OUT": 3258457896,
                        "CREDITUSED": 125874,
                        "URL": "https:\/\/icip.ito.gov.ir\/index.php\/site\/page\/view\/list_ip"
                    },
                    {
                        "NAME": "SATIA",
                        "FNAME": "رایگانها",
                        "IN": 895656456,
                        "OUT": 655646,
                        "CREDITUSED": 148759,
                        "URL": ""
                    },
                    {
                        "NAME": "MESSENGER",
                        "FNAME": "پیام رسان داخلی",
                        "IN": 64645655,
                        "OUT": 0,
                        "CREDITUSED": 64587,
                        "URL": ""
                    }
                ];*/

        let arr = [];
        let arrayX = [];
        // let arrayX = [];

        let arrayA = [];
        let arrayB = [];
        let arrayC = [];
        let arrayD = [];

        for (let i = 0; i < item.length; i++) {
            //let arrayY = [];
            arrayA.push(Tools.convertOnlyGig(item[i].OUT));
            arrayB.push(Tools.convertOnlyGig(item[i].IN));
            arrayC.push(Tools.convertOnlyGig(item[i].OUT + item[i].IN, myService));
            arrayD.push(Tools.M_convertOnlyGig(item[i].CREDITUSED, myService));

            arrayX.push(Tools.SubString(item[i].FNAME ? item[i].FNAME : item[i].MONTH, 20));
            // arrayX.push(item[i].FNAME)
            //  arr.push({
            //      y: arrayY,
            //      marker: ["ارسال", "دریافت"]
            //  })
        }
        setDataChart({
            labels: arrayX,
            datasets: [
                {
                    label: 'ترافیک مصرفی',
                    data: arrayC,
                    backgroundColor: '#00c218',
                },
                {
                    label: 'اعتبار مصرفی',
                    data: arrayD,
                    backgroundColor: '#c20080',
                },
                /*      {
                          label: '# of Green Votes',
                          data: [3, 10, 13, 15, 22, 30],
                          backgroundColor: 'rgb(75, 192, 192)',
                      },*/
            ],
        });

        console.log(
            'Occurs ONCE, AFTER the initial render.',
        );
    }, []);

    return <View style={{
        flex: 1,
        // width: "100%",
        // height: "100%",
        backgroundColor: '#fff'
        , paddingVertical: moderateScale(10)
        , paddingHorizontal: moderateScale(4),
    }}>
        {title ?
            <HMTextView
                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                text={title}
                //  text={"ثبت و بستن تیکت"}
                type={'bold'}
                style={[{
                    fontSize: moderateScale(16),
                    marginVertical: moderateScale(2),
                    //     marginHorizontal: moderateScale(4),
                    color: Colors.blackLight,
                }, styleTitle]}
                styleRoot={[{alignSelf: 'center'}, styleRootTitle]}
            />
            :
            null
        }


        <Bar options={options} data={props.dataChart ? props.dataChart : dataChart}/>

    </View>;
}

export default HMStackedBarChart;
